import { particles } from 'app/contracts/Particles';
import { ParticleBehaviourTagType } from 'app/enum/Particles';

export abstract class ParticleBehaviour implements particles.ParticleBehaviour {
	public destroyed: boolean = false;

	public index: number;
	public particleIndex: number;

	protected _sceneProps: particles.SceneProps;
	protected _particleProps: particles.ParticleProps;
	protected _animatedProps: particles.ParticleProperties;
	protected _tags: Array<ParticleBehaviourTagType> = [];
	public _active: boolean = false;

	public constructor(
		sceneProps: particles.SceneProps,
		particleProps: particles.ParticleProps,
		animatedProps: particles.ParticleProperties
	) {
		this._sceneProps = sceneProps;
		this._particleProps = particleProps;
		this._animatedProps = animatedProps;
		this.particleIndex = this._particleProps.ref.getLookupIndex();
	}

	public set active(v: boolean) {
		if (this._active != v) {
		}

		this._active = v;
	}

	public get active() {
		return this._active;
	}

	//Public methods
	//---------------------------------------------------------------------------------------
	public tick(): void {}
	public destroy(): void {
		this.destroyed = false;
		this.active = false;
		this._tags = null;
	}

	public resize(): void {}

	public hasTag(tag: ParticleBehaviourTagType): boolean {
		return this._tags.indexOf(tag) !== -1;
	}
	public addTag(...tags: Array<ParticleBehaviourTagType>): void {
		tags.forEach((tag) => this._tags.push(tag));
	}
}
